import { createContext, useState } from "react";

export const HotelContext = createContext();

export const HotelProvider = ({ children }) => {
    const [hotelSearchParams, setHotelSearchParams] = useState({
        destination: null,
        checkInDate: "",
        checkOutDate: "",
        rooms: [
            {
                adults: 2,
                children: 0,
                childrenAges: [],
            },
        ],
    });
    const [availabilityResults, setAvailabilityResults] = useState(null);
    const [availabilityLoading, setAvailabilityLoading] = useState(false);
    const [availabilityError, setAvailabilityError] = useState(null);
    const [providers, setProviders] = useState(null);
    const [hotelSelection, setHotelSelection] = useState({
        selectedHotel: null,
        cancellationPolicies: null,
        comments: null,
        seletedRates: null,
        checkRateResult: null,
        totalPrice: null,
        supplementsArray : [],
    });
    const [ guestsInformation , setGuestsInformation ] = useState(null)
    return (
        <HotelContext.Provider
            value={{
                hotelSearchParams,
                setHotelSearchParams,
                availabilityResults,
                setAvailabilityResults,
                availabilityLoading,
                setAvailabilityLoading,
                providers,
                setProviders,
                availabilityError,
                setAvailabilityError,
                hotelSelection,
                setHotelSelection,
                guestsInformation,
                setGuestsInformation,
            }}
        >
            {children}
        </HotelContext.Provider>
    );
};
